import {connect} from 'react-redux'

import type {State} from '../../../../../../reducers/types'
import {isAnyActionPerforming} from '../Rules.selectors'

import RulesList from './RulesList'
import type {OwnProps, StateProps} from './RulesList.types'

const mapStateToProps: (arg0: State, arg1: OwnProps) => StateProps = (state, {holderNode}) => ({
  disableButtons: isAnyActionPerforming(state, holderNode),
})

export default connect(mapStateToProps)(RulesList)
